
import { SitemapUrl, UrlCategories } from './types/analysisTypes';

export const categorizeUrls = (urls: SitemapUrl[]): UrlCategories => {
  return {
    other: urls.filter(url => {
      const path = url.loc.toLowerCase();
      return !path.includes('/blog/') && 
             !path.includes('/products/') && 
             !path.includes('/services/') && 
             !path.includes('/about/') &&
             !path.match(/(privacy|terms|gdpr|sitemap|robots)/);
    }).map(url => url.loc),
    blog: urls.filter(url => url.loc.toLowerCase().includes('/blog/')).map(url => url.loc),
    products: urls.filter(url => url.loc.toLowerCase().includes('/products/')).map(url => url.loc),
    services: urls.filter(url => url.loc.toLowerCase().includes('/services/')).map(url => url.loc),
    about: urls.filter(url => url.loc.toLowerCase().includes('/about/')).map(url => url.loc),
    technical: urls.filter(url => url.loc.toLowerCase().match(/(privacy|terms|gdpr|sitemap|robots)/)).map(url => url.loc)
  };
};
